const curry = require('curry');

const fillRegion = curry(require('./fillRegion'));
const calcRegionsBounds = require('./calcRegionsBounds');
const rgba = require('./rgba');

module.exports = function selectItem(map, item) {
	map.geoObjects.each((geoObject) => geoObject.options.set('fillColor', 'rgba(0,0,0,0)'));
	map.setBounds(
		item.regions
			.map(fillRegion(rgba(item.color, 0.5)))
			.slice(0, (item.regions.length > 3) ? (item.regions.length - 2) : undefined)
			.reduce(calcRegionsBounds, null)
	);
};



/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/selectItem.js
 **/